import React, { Component } from "react";
import { Field, reduxForm, FormSection, formValueSelector, reset } from "redux-form";
import { renderInput, renderTextArea, renderDatePicker, renderDropdown, renderCheckbox } from "../common/renderinput";
import { Nav,NavItem,NavLink,TabContent,TabPane } from 'reactstrap';
import classnames from 'classnames';

const q = [
    {valueField: 1, textField:"Confirmation Order"},
    {valueField: 2, textField:"Corrective Deed"},
    {valueField: 3, textField:"Deed In Lieu"},
    {valueField: 4, textField:"Foreclosure Deed"},
    {valueField: 5, textField:"Quit Claim Deed"},
    {valueField: 6, textField:"Sheriff’s Deed"},
    {valueField: 7, textField:"Special Warranty Deed"},
    {valueField: 8, textField:"Trustees Deed"}
];
class TaxPaymentForm extends Component {
    constructor(...args) {
        super(...args);
    }
    render() {
        return (
          <>
                                            <div className="form-row col-12 pl-0 mt-2">
                                                <div className="col-2">
                                                    <Field
                                                    name="TaxType"
                                                    component={renderInput}
                                                    label="Tax Type"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="TaxPeriod"
                                                    component={renderInput}
                                                    label="Tax Period"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="TaxYear"
                                                    component={renderInput}
                                                    label="Tax Year"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="Amount"
                                                    component={renderInput}
                                                    label="Amount"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="Date"
                                                    component={renderInput}
                                                    label="Date"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="Status"
                                                    component={renderInput}
                                                    label="Status"
                                                    isLabel={true}
                                                    />
                                                </div>
                                            </div>

                                            <div className="form-row col-12 pl-0 mt-2">
                                                <div className="col-2">
                                                    <Field
                                                    name="DiscountDate"
                                                    component={renderInput}
                                                    label="Discount Date"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="DiscountAmount"
                                                    component={renderInput}
                                                    label="Discount Amount"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="FaceDate"
                                                    component={renderInput}
                                                    label="Face Date"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="FaceAmount"
                                                    component={renderInput}
                                                    label="Face Amount"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="PenaltyDate"
                                                    component={renderInput}
                                                    label="Penalty Date"
                                                    isLabel={true}
                                                    />
                                                </div>
                                                <div className="col-2">
                                                    <Field
                                                    name="Penalty"
                                                    component={renderInput}
                                                    label="Penalty Amt"
                                                    isLabel={true}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-row col-12 pl-0 mt-2">
                                                <div className="col-12">
                                                    <Field
                                                    name="Comments"
                                                    component={renderTextArea}
                                                    label="Discount Date"
                                                    isLabel={true}
                                                    />
                                                </div>
                                            </div>
                                            
          </>
        );
    }
}
export default TaxPaymentForm;